function clidName(clid) {
  if (!clid) {
    return '';
  }
  const match = String(clid).match(/^"([^"]*)"/);
  return match ? match[1] : '';
}

function clidNumber(clid) {
  if (!clid) {
    return '';
  }
  const match = String(clid).match(/<([^>]*)>/);
  return match ? match[1] : '';
}

function stripGluedPrefix(name, num) {
  const displayName = name || '';
  const number = num || '';
  if (!displayName || !number || displayName === number) {
    return '';
  }
  if (displayName.endsWith(number)) {
    return displayName.slice(0, displayName.length - number.length);
  }
  if (displayName.includes(number)) {
    return displayName.replace(number, '');
  }
  return '';
}

export function deriveCallingCode(cnam, cnum, clid) {
  const number = cnum || clidNumber(clid);
  return stripGluedPrefix(cnam, number) || stripGluedPrefix(clidName(clid), number);
}
